import React, { Component } from 'react';
import axios from 'axios'
import { Grid, Button, Icon } from 'semantic-ui-react'
import { serverIp, firebaseAuth } from '../../../config/constants.js'
import * as UiConsts from '../../../config/UiConstants'
import MainCard from '../MainPageCards'
import { Sectionheader } from '../NewSiteParts'
import { TrackFbClicks } from '../../../Utilities/Utils'
import ReactPixel from 'react-facebook-pixel';
import { checkAdminEmail } from '../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';


import createBrowserHistory from 'history/createBrowserHistory';
import { send_facebook_viewContent } from '../MiscUtils.js';
const history = createBrowserHistory({ forceRefresh: true });

export default class ViewTemplatesByType extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user: '',
            admin: false,
            algoliaUser:null,
            loading: true,
            adset: 'none',
            templates: []
        }
    }


    componentDidMount() {

        let tempAdmin = false;

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }

            /**
             * CHECK FOR CAMPAIGN
             */
            if (this.props.match.params.campaign && this.props.match.params.fbId) {
                console.log("fbx1 fbId is valid:" + this.props.match.params.fbId);
                console.log("fbx12 campaign is valid:" + this.props.match.params.campaign);
                TrackFbClicks(this.props.match.params.fbId, this.props.match.params.campaign, tempAdmin);

            } else if (this.props.match.params.fbId) {

                console.log("fbx1 fbId is valid:" + this.props.match.params.fbId);
                TrackFbClicks(this.props.match.params.fbId, "unknown", tempAdmin);
            }

            //SET FB CAMPAIGN NAME FROM URL..
            if (this.props.match.params.adset) {
                console.log("adset12 adset is valid:" + this.props.match.params.adset);

                this.setState({ adset: this.props.match.params.adset })
            }
        })


        this.loadTemplates();
    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            admin: returnObject.isAdmin,
            //isAdmin: returnObject.isAdmin,
        })
    }

    facebookViewContent = (content) => {

        //check for admin

        console.log("tmpx12 ++++++++++: facebookViewContent:" + content);

        if (this.state.admin) {
            console.log("tmpx13 its AN ADMIN NOT LOGGINED VIEW CONTONET");
        } else {
            console.log("tmpx13 its not AN ADMIN LOGGINED VIEW CONTONET");
            ReactPixel.track('ViewContent', {
                content_name: content,
                content_category: 'Main Tile:template',
                content_ids: ['template'],
                content_type: 'product'
            })
        }
    }

    loadTemplates = () => {

        /**
         * CHANGING THE WAY TEMPLATE RETRIEVAL WORKS BY SWITCHING TO NEW TABLE..BUT DON'T WANT TO UPDATE ALL THE OLD TEMPLATE
         * NOW SWITCHING getAllTemplatesInCategory WILL DETERMINE IF TO PULL FROM NEW TABLE OR NOT.. 
         */

        let getAllTemplatesInCategory = false;

        if (this.props.match.params.templateType === 'avengers') {
            console.log("avx1 avengers!");
            getAllTemplatesInCategory = true;
        }

        //TEMPORARY SEND TO MAIN PAGE FOR COUPLES..
        // if(this.props.match.params.templateType === 'couples'){
        //     history.push("/");
        // }

        axios.post(serverIp + 'templates/getTemplates', {
            apiKey: 'xcbcvbxcvb',
            templateType: this.props.match.params.templateType,
            getAllTemplatesInCategory: getAllTemplatesInCategory
        })
            .then((response) => {
                console.log(response);
                console.log("response.templates size:" + response.data.templates.length);
                this.setState({
                    templates: response.data.templates,
                    loading: false
                })

                console.log("tmpx1 response.data.template.itemCode:" + this.props.match.params.templateType);
                //this.facebookViewContent(this.props.match.params.templateType);

                if (this.state.admin) {
                    console.log("infinity pixel admin is TRUE..not loading VIEW CONTENT");
                } else {
                    console.log("pixel admin is FALSE..sending VIEW CONTENT:" + this.props.match.params.templateType);
                    send_facebook_viewContent(this.props.match.params.templateType, "none");
                }


                // this.setTemplates(response.templates);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    render() {

        const templatesList = this.state.templates.map((template) =>

            <Grid.Column>
                <MainCard showMainForm={this.showMainForm}
                    image={template.imageUrl}
                    imageSize='massive'
                    itemTypeDescription={template.fullTotalDescription}
                    itemType={template.templateType.itemType.itemType}
                    fullDescription={''}
                    shortDescriptions={template.cost + ' UGX EA'}
                    showMainForm={this.props.showMainForm}
                    templateId={template.idtemplates}
                    ivanDescription={template.ivanDescription}
                    admin={this.state.admin}
                    adset={this.state.adset} />
            </Grid.Column>
        )

        const whatsappContact = <Grid.Column>
            <br />
            <form>
                <Button fluid color='green' type="submit" formaction="http://bit.ly/2t2Ckjr" target="_blank">
                    <Icon name='whatsapp' /> Questions? Click here to Whatsapp us
        </Button>
            </form>

        </Grid.Column>



        return (

            this.state.loading ? <UiConsts.LoadingComponent /> :
                <div>
                    <Sectionheader
                        mainHeader={'Order any of the items below'}
                        subHeader={'We will contact for your delivery details'} />
                    <br />
                    <Grid container stackable columns={3}>
                        {templatesList}

                    </Grid>
                    {whatsappContact}
                </div>


        )
    }
}


// WEBPACK FOOTER //
// ./src/components/newSite/templates/ViewTemplatesByType.js